import { createContext, useContext } from 'react';
import Store from './store';

export const StoreContext = createContext(Store);

export const StoreProvider = StoreContext.Provider;

export const useStore = () => useContext(StoreContext);
